import React, { PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import { objectTitle } from '../../common';

const ObjectTitle = ({ object }) => (
    <span>{ objectTitle(object) }</span>
);

ObjectTitle.propTypes = {
    object: PropTypes.object.isRequired,
};

export default CSSModules(ObjectTitle);


// WEBPACK FOOTER //
// ./app/components/Object/ObjectTitle.jsx